import React, { useEffect, useState, useCallback } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import UserDetailsModal from "./UserDetailsModal";

const ProfileMenu = ({ t }) => {
  const [menu, setMenu] = useState(false);
  const parsedUser = JSON.parse(localStorage.getItem("authUser"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [username, setUsername] = useState("Admin");
  const [userInitials, setUserInitials] = useState("A");

  // 🔹 Update user details from localStorage
  const updateUserDetails = useCallback(() => {
    const userDetails = JSON.parse(localStorage.getItem("authUser"));

    if (userDetails) {
      const firstName = userDetails.first_name || "";
      const lastName = userDetails.last_name || "";
      const fullName = `${firstName} ${lastName}`.trim();
      const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

      setUsername(fullName || "Admin");
      setUserInitials(initials || "A");
    } else {
      setUsername("Admin");
      setUserInitials("A");
    }
  }, []);

  // 🔹 Handle localStorage changes (cross-tab)
  const handleStorageChange = useCallback(
    (e) => {
      if (e.key === "userDetails") {
        updateUserDetails();
      }
    },
    [updateUserDetails]
  );

  // 🔹 Lifecycle replacement
  useEffect(() => {
    updateUserDetails();

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("userDetailsUpdated", updateUserDetails);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("userDetailsUpdated", updateUserDetails);
    };
  }, [handleStorageChange, updateUserDetails]);

  // 🔹 Handlers
  const toggle = () => setMenu((prev) => !prev);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("schema");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
  };

  
  return (
    <React.Fragment>
      {isModalOpen === true && (<UserDetailsModal onClose={closeModal} id={parsedUser?.id}/>)}
      
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="d-inline-block user-dropdown"
      >
        <DropdownToggle
          tag="button"
          className="btn header-item waves-effect d-flex align-items-center"
          id="page-header-user-dropdown"
        >
          {/* Profile Icon */}
          <div
            className="rounded-circle header-profile-user d-flex align-items-center justify-content-center"
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#f9992d",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {userInitials}
          </div>

          {/* Username */}
          <span
            className="ms-2 d-inline-block"
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: "#fff",
              lineHeight: "1.2",
            }}
          >
            {username}
          </span>

          <i
            className="mdi mdi-chevron-down ms-2"
            style={{ color: "#fff", fontSize: "18px" }}
          />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem onClick={openModal}>
            <i className="ri-user-line align-middle me-1"></i>{" "}
            {t("Profile")}
          </DropdownItem>

          <DropdownItem divider />

          <DropdownItem
            onClick={handleLogout}
            tag="a"
            href="/logout"
            className="text-danger"
          >
            <i className="ri-shut-down-line align-middle me-1 text-danger"></i>{" "}
            {t("Logout")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {/* User Details Modal */}
      {/* {isModalOpen && (
        <UserDetailsModal onClose={closeModal} id={null} type="user" />
      )} */}
    </React.Fragment>
  );
};

export default withTranslation()(ProfileMenu);
